import { BuyHoldingPayload, TradeCommand } from "../../../services/holdings";
import { isBlank } from "../../../utils/taxWithheld";
import { PanelErrorRoute } from "./panelErrors";
import { CashbackFundingFormValues } from "./types";

// Source messages first: they all start with "Cashback" too.
export const CASHBACK_ERROR_ROUTES: readonly PanelErrorRoute<
  keyof CashbackFundingFormValues
>[] = [
  ["Cashback source account needs", "cashbackEur"],
  ["Cashback from ", "cashbackSource"],
  ["Cashback source", "cashbackSource"],
  ["Cashback needs a source", "cashbackSource"],
  ["Cashback ", "cashbackEur"],
];

// Both keys or neither: an empty amount is how a correction removes the cashback.
export const cashbackFundingPayloadOf = ({
  cashbackEur,
  cashbackSource,
}: CashbackFundingFormValues): Pick<
  BuyHoldingPayload,
  "cashbackEur" | "cashbackSourceAccountId"
> =>
  isBlank(cashbackEur) || cashbackSource === null
    ? {}
    : {
        cashbackEur: Number(cashbackEur),
        cashbackSourceAccountId: Number(cashbackSource.value),
      };

export const recordedCashbackValuesOf = (
  cashback: TradeCommand["cashback"],
): CashbackFundingFormValues => ({
  cashbackEur: cashback?.amountEur ?? "",
  cashbackSource:
    cashback?.sourceAccountId == null
      ? null
      : {
          value: String(cashback.sourceAccountId),
          label: cashback.sourceAccountName ?? "",
        },
});
